// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CZRaN","type":"styles_type__2DnT9","choices":"styles_choices__3zA1e"};